import React, { Component } from 'react';
import { Input, Form, Checkbox, Modal,Button } from 'antd';

import { Parse } from 'parse';

import {connect} from 'react-redux';
import {FormattedMessage, FormattedHTMLMessage, defineMessages ,   injectIntl} from 'react-intl';

import createHistory from 'history/createBrowserHistory';
import * as actions from '../actions';

import { notiFormForError } from '../components/notificationForm';
import PolicyModal from '../components/PolicyModal';

import '../styles/Signup.css';

const FormItem = Form.Item;

const messages = defineMessages({
  inputEmail:{
    id:'Signup.input.email',
    defaultMessage:'Enter your e-mail'
  },
  emailRequired:{
    id:'Signup.email.error.required',
    defaultMessage:'Email is required'
  },
  emailType:{
    id:'Signup.email.error.Type',
    defaultMessage:'Email is not a valid email'
  },
  inputNickname:{
    id:'Signup.input.nickname',
    defaultMessage:'Enter your nickname'
  },
  nicknameRequired:{
    id:'Signup.nickname.error.required',
    defaultMessage:'Nickname is required'
  },
  nicknameMinLength:{
    id:'Signup.nickname.error.minLength',
    defaultMessage:'Nickname must be at least 3 characters'
  },
  nicknameMaxLength:{
    id:'Signup.nickname.error.maxLength',
    defaultMessage:'Nickname cannot have more than 20 characters'
  },
  nicknameFormat:{
    id:'Signup.nickname.error.foramt',
    defaultMessage:'Nickname must be registered in English, numbers, and special characters.'
  },
  nicknameOverlap:{
    id:'Signup.nickname.error.overlap',
    defaultMessage:'This nickname has already been used.'
  },
  inputPassword:{
    id:'Signup.input.password',
    defaultMessage:'Password'
  },
  passwordRequired:{
    id:'Signup.password.error.required',
    defaultMessage:'Password is required'
  },
  inputConfirm:{
    id:'Signup.input.confirm',
    defaultMessage:'Confirm Password'
  },
  confirmRequired:{
    id:'Signup.confirm.error.required',
    defaultMessage:'Confirm Password is required'
  },
  confirmCheckPassword:{
    id:'Signup.confirm.error.check.password',
    defaultMessage:'Two passwords that you enter is inconsistent'
  },
  agreeTerms:{
    id:'Signup.noti.terms.check',
    defaultMessage:'Please read and agree to the Terms and Conditions 📝'
  },
});


class Signup extends Component{

  constructor(props) {
    super(props);

    this.state = {
      email: '',
      password: '',
      nickname: {
        ko: '',
        en: ''
      },
      errorMessage:'',
      visible:false,
      agreementVisible: false,
      agreementCheckbox:false,
    };

    this.handleEmailInputChange = this.handleEmailInputChange.bind(this);
    this.handleNicknameInputChange = this.handleNicknameInputChange.bind(this);
    this.handlePasswordInputChange = this.handlePasswordInputChange.bind(this);
  }

  render() {
    const { getFieldDecorator, getFieldError} = this.props.form;
    const errorMessage = this.state.errorMessage;
    const {formatMessage} = this.props.intl;

      return (
        <div>
          <p className="headline">
            <FormattedMessage
              id={'Signup.headline'}
              defaultMessage={'Sign Up'}
            />
          </p>
          <div className="sign-box">

            <Form onSubmit={this._handleSignup}>
                  <FormItem
                    validateStatus={ errorMessage || getFieldError('email') ? 'error' : ''}
                    >
                    {getFieldDecorator('email', {
                      rules: [
                        { required: true, message: formatMessage(messages.emailRequired) },
                        {type:'email', message: formatMessage(messages.emailType)}
                      ],
                    })(
                      <Input
                        placeholder={formatMessage(messages.inputEmail)}
                        className="sign-input"
                        onChange={this.handleEmailInputChange}
                      />
                    )}
                  </FormItem>
                  <FormItem
                    validateStatus={errorMessage || getFieldError('nickname') ? 'error' : ''}
                    >
                    {getFieldDecorator('nickname', {
                      rules: [
                      { required: true, message: formatMessage(messages.nicknameRequired)},
                      { min : 3, message: formatMessage(messages.nicknameMinLength) },
                      { max : 20, message: formatMessage(messages.nicknameMaxLength) },
                      { pattern :/(^[a-zA-Z0-9,./?~`!@#${}%^&*()-_=+'"|<>\s]*$)/, message : formatMessage(messages.nicknameFormat) }
                      ],
                    })(
                      <Input
                      className="sign-input"
                      placeholder={formatMessage(messages.inputNickname)}
                      onChange={this.handleNicknameInputChange}
                      />
                    )}
                  </FormItem>
                  <FormItem
                    validateStatus={errorMessage || getFieldError('password') ? 'error' : ''}
                    help={errorMessage ||
                      <FormattedHTMLMessage
                        id="Signup.password.error.pattern"
                        defaultMessage="Please set up a combination of eight or more alphanumeric characters,<br/>numbers, and special characters."
                      />
                      }>
                    {getFieldDecorator('password', {
                      rules: [
                        { required: true, message: formatMessage(messages.passwordRequired) },
                        // eslint-disable-next-line no-useless-escape
                        { pattern: /^(?=.*[a-z])(?=.*[!@#$%^*()\-_=+\\\|\[\]{};:\'",.<>\/?])(?=.*[0-9])(?=.{8,})/ },
                      ],
                    })(
                      <Input
                      className="sign-input"
                      placeholder={formatMessage(messages.inputPassword)}
                      type="password"
                      onChange={this.handlePasswordInputChange}
                      />
                    )}

                  </FormItem>
                  <FormItem
                    validateStatus={errorMessage || getFieldError('confirm') ? 'error' : ''}
                    >
                    {getFieldDecorator('confirm', {
                      rules: [
                        { required: true, message: formatMessage(messages.confirmRequired) },
                        { validator: this._checkPassword,}
                      ],
                    })(
                      <Input
                        className="sign-input"
                        placeholder={formatMessage(messages.inputConfirm)}
                        type="password"
                        onChange={this.handlePasswordInputChange}
                      />
                    )}
                  </FormItem>

                  <FormItem>
                    {getFieldDecorator('agreement', {
                      valuePropName: 'checked',
                    })(
                      <Checkbox onChange={this.agreementCheck}>
                      <FormattedMessage
                        id={'Signup.terms.checkbox'}
                        defaultMessage={'I agree'}
                      />

                      </Checkbox>
                    )}
                  </FormItem>

                  <FormItem>
                    <button className="sign-button" type="primary" htmltype="submit">
                      <FormattedMessage
                        id={'Signup.btn'}
                        defaultMessage={'Sign up'}
                      />
                    </button>
                  </FormItem>
            </Form>
          </div>
          {/*회원가입 완료시 안내 모달*/}
          <Modal
            visible={this.state.visible}
            onOk={this.handleOk}
            onCancel={this.handleCancel}
            footer={[
              <Button key="submit"
                type="primary"
                size="large"
                style={{backgroundColor:'#5fffaf',border:'none',width:'85px'}}
                loading={this.state.loading}
                onClick={this.handleOk}
                >
                <FormattedMessage
                  id={'Signup.modal.btn'}
                  defaultMessage={'OK'}
                />
              </Button>,
              ]}
            className="reset-modal">
            <p className="reset-title">
              <FormattedMessage
                id={'Signup.modal.title'}
                defaultMessage={'Check your E-mail'}
              />
            </p>
            <span className="reset-explan-underline">
              <FormattedHTMLMessage
                id={'Signup.modal.explain.underline'}
                defaultMessage={'Didn&#39;t receive the E-mail?'}
              />
            </span>&#x1F914;&#x1F914;&#x1F914;
            <p className="reset-explan">
              <FormattedMessage
                id={'Signup.modal.explain'}
                defaultMessage={'Please check your E-mail address or spam.'}
              />
            </p>
          </Modal>
          {/* 약관 내용 보여주는 모달 */}
          <PolicyModal
            visible = {this.state.agreementVisible}
            onCancelFunc = {() => this.setState({agreementVisible: false})}
            checkedFunc = {() => this.setState({agreementVisible: false, agreementCheckbox:true})}
            unCheckedFunc = {() => this.setState({agreementCheckbox:false})}
            checkTitle={<FormattedMessage
              id={'Signup.terms.checkbox'}
              defaultMessage={'I agree'}
            />}
          />
        </div>
      );
    }


    handleEmailInputChange(e) {
      this.setState({
        email: e.target.value
      });
    }

    handleNicknameInputChange(e) {
      this.setState({
        nickname: {
          ko: e.target.value,
          en: e.target.value
        }
      });
    }

    handlePasswordInputChange(e) {
      this.setState({
        password: e.target.value
      });
    }

    handleOk = ()=>{
      this.setState({visible: false});
      console.log('parse.user : ', Parse.User.current());
      sessionStorage.clear();
      const history = createHistory();
      history.push('/');
      history.go();
    }

    handleCancel = () => {
       this.setState({ visible: false });
     }

    _checkPassword = (rule, value, callback) => {
      const form = this.props.form;
      const {formatMessage}=this.props.intl;
      if (value && value !== form.getFieldValue('password')) {
        callback(formatMessage(messages.confirmCheckPassword));
      } else {
        callback();
      }
    }

    agreementCheck = ()=>{
      const agreementVisible = this.state.agreementVisible;
      this.props.form.validateFields((err, values)=>{
        if (agreementVisible === false && values.agreement !== true) {
         this.setState({agreementVisible:true});
        } else {
          this.setState({agreementVisible:false});
        }
      });

    }

    _handleSignup = (event) => {
      const { email, password, nickname } = this.state;
      const {formatMessage} = this.props.intl;
      event.preventDefault();
      this.props.form.validateFields((err, values) => {
          if (values.agreement === undefined || values.agreement === false || this.state.agreementCheckbox === false){
            notiFormForError(this.props.intl.locale, formatMessage(messages.agreeTerms));
          }
          else if (!err) {
              const trimNickname = {
                ko: nickname.ko.trim(),
                en: nickname.en.trim()
              };
              var user = new Parse.User();
              user.set('username', email);
              user.set('password', password);
              user.set('email', email);
              user.set('nickname', trimNickname);

              user.signUp()
                .then(()=>{
                  this.setState({visible:true});
                  this.props.signupSuccess();
                })
                .catch((error)=>{
                  if (error.code === 202){//이미 존재하는 user일 경우
                    alert(error.message);
                  }
                  if (error.code === 1100){//닉네임이 중복일 경우
                    notiFormForError(this.props.intl.locale, formatMessage(messages.nicknameOverlap));
                  } 
                  if (error.code === 142){//pw 양식 틀렸을 때: 소문자+숫자+특수문자 8자 이상
                    this.setState({
                      errorMessage:(
                        <span>
                        Please set up a combination of eight or more alphanumeric characters,<br/>
                        numbers, and special characters.
                        </span>
                        )
                    });
                  }
                  this.props.signupFailed(error);
                });
            //////////////
            }
          });


        // event.preventDefault();

    }//_handleSignup end


}//signup class end
  
Signup = Form.create({})(injectIntl(Signup));

const mapStateToProps = (state)=>{
  return {
    ...state.sessionReducer
  };
};

const mapDispatchToProps = (dispatch)=>{
  return {
    signupSuccess:()=>{dispatch(actions.signupSuccess());},
    signupFailed:(error)=>{dispatch(actions.signupFailed(error));}
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Signup);
